unit DonationClaimStatusInterrogationForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.StdCtrls,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WebForm.Core,
  GA.Return.Types,
  XData.Web.Client,
  SMX.Web.Utils;

type
  TDonationClaimStatusInterrogationForm = class(TCoreWebForm)
    HeaderLabel: TLabel;
    DetailsMemo: THTMLDiv;
    RefreshButton: TButton;
    CloseButton: TButton;
    procedure WebFormShow(Sender: TObject);
    [async]
    procedure RefreshButtonClick(Sender: TObject); async;
    procedure CloseButtonClick(Sender: TObject);
  private
    FDonationId: Integer;
    FPreviewRequest: TDonationClaimStatusPreviewRequest;
    FStatusRecomputed: Boolean;
    FRecalculateInProgress: Boolean;
    FCurrentClaimStatus: string;
    FCurrentErrorText: string;
    [async]
    procedure LoadInterrogation; async;
    function ResponseObject(const AValue: TJSObject): TJSObject;
    function ReadString(const AObject: TJSObject; const APropertyName: string): string;
    function ReadBoolean(const AObject: TJSObject; const APropertyName: string): Boolean;
    function ReadInteger(const AObject: TJSObject; const APropertyName: string): Integer;
    function IsFailureClaimStatus(const AStatus: string): Boolean;
  public
    property DonationId: Integer read FDonationId write FDonationId;
    property PreviewRequest: TDonationClaimStatusPreviewRequest read FPreviewRequest write FPreviewRequest;
    property StatusRecomputed: Boolean read FStatusRecomputed;
    property CurrentClaimStatus: string read FCurrentClaimStatus;
    property CurrentErrorText: string read FCurrentErrorText;
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses
  MainDataModule;

var
  GLastPreviewInterrogationFingerprint: string = '';
  GLastPreviewInterrogationHeader: string = '';
  GLastPreviewInterrogationText: string = '';
  GLastPreviewInterrogationClaimStatus: string = '';
  GLastPreviewInterrogationErrorText: string = '';

function TDonationClaimStatusInterrogationForm.ResponseObject(const AValue: TJSObject): TJSObject;
begin
  Result := nil;
  if not Assigned(AValue) then
    Exit;

  if Assigned(AValue['value']) then
    Result := TJSObject(AValue['value'])
  else
    Result := AValue;
end;

function TDonationClaimStatusInterrogationForm.ReadString(const AObject: TJSObject;
  const APropertyName: string): string;
begin
  Result := '';
  if Assigned(AObject) and AObject.hasOwnProperty(APropertyName) and Assigned(AObject[APropertyName]) then
    Result := Trim(JS.toString(AObject[APropertyName]));
end;

function TDonationClaimStatusInterrogationForm.ReadBoolean(const AObject: TJSObject;
  const APropertyName: string): Boolean;
begin
  Result := False;
  if Assigned(AObject) and AObject.hasOwnProperty(APropertyName) and Assigned(AObject[APropertyName]) then
    Result := Boolean(AObject[APropertyName]);
end;

function TDonationClaimStatusInterrogationForm.ReadInteger(const AObject: TJSObject;
  const APropertyName: string): Integer;
begin
  Result := 0;
  if Assigned(AObject) and AObject.hasOwnProperty(APropertyName) and Assigned(AObject[APropertyName]) then
    Result := JS.toInteger(AObject[APropertyName]);
end;

function TDonationClaimStatusInterrogationForm.IsFailureClaimStatus(const AStatus: string): Boolean;
begin
  Result :=
    SameText(AStatus, 'Unknown') or
    SameText(AStatus, 'Failed') or
    SameText(AStatus, 'Invalid') or
    SameText(AStatus, 'TooOld') or
    SameText(AStatus, 'NonGiftAidable') or
    SameText(AStatus, 'NGACustomerRequest');
end;

procedure TDonationClaimStatusInterrogationForm.WebFormShow(Sender: TObject);
begin
  inherited;
  FStatusRecomputed := False;
  FCurrentClaimStatus := '';
  FCurrentErrorText := '';
  RefreshButton.Visible := False;
  LoadInterrogation;
end;

procedure TDonationClaimStatusInterrogationForm.LoadInterrogation;
var
  lResponse: TXDataClientResponse;
  lRoot: TJSObject;
  lSteps: TJSArray;
  lStep: TJSObject;
  lLines: TStringList;
  lReasons: TStringList;
  lPassedChecks: TStringList;
  lI: Integer;
  lLine: string;
  lShowReasons: Boolean;
  lCurrentStatus: string;
  lCurrentErrorText: string;
  lComputedStatus: string;
  lComputedErrorText: string;
  lStatusMismatch: Boolean;
  lClaimInfo: string;
  lStatusExplanation: string;
  lAdjustmentInfo: string;
  lLegacyMessage: string;
  lAmountText: string;
  lDateText: string;
  lDonationId: Integer;
  lPreviewFingerprint: string;
  lIsLocked: Boolean;
begin
  lPreviewFingerprint := '';
  lIsLocked := False;
  if (FDonationId <= 0) and Assigned(FPreviewRequest) then
  begin
    lPreviewFingerprint := FPreviewRequest.BuildFingerprint;
    if (lPreviewFingerprint <> '') and (lPreviewFingerprint = GLastPreviewInterrogationFingerprint) and
      (GLastPreviewInterrogationText <> '') then
    begin
      HeaderLabel.Caption := GLastPreviewInterrogationHeader;
      FCurrentClaimStatus := GLastPreviewInterrogationClaimStatus;
      FCurrentErrorText := GLastPreviewInterrogationErrorText;
      if Assigned(DetailsMemo.ElementHandle) then
        TJSHTMLElement(DetailsMemo.ElementHandle).textContent := GLastPreviewInterrogationText;
      RefreshButton.Visible := False;
      Exit;
    end;
  end;

  if Assigned(DetailsMemo.ElementHandle) then
    TJSHTMLElement(DetailsMemo.ElementHandle).textContent := 'Loading...';
  RefreshButton.Enabled := False;
  try
    if FDonationId > 0 then
      lResponse := await(TXDataClientResponse,
        MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetDonationClaimStatusInterrogation', [FDonationId]))
    else if Assigned(FPreviewRequest) then
      lResponse := await(TXDataClientResponse,
        MainData.WebClient.RawInvokeAsync('IGiftAiderService.PreviewDonationClaimStatusInterrogation', [FPreviewRequest.ToJSONObject]))
    else
    begin
      if Assigned(DetailsMemo.ElementHandle) then
        TJSHTMLElement(DetailsMemo.ElementHandle).textContent := 'Unable to interrogate this donation.';
      Exit;
    end;
    lRoot := ResponseObject(lResponse.ResultAsObject);

    lLines := TStringList.Create;
    lReasons := TStringList.Create;
    lPassedChecks := TStringList.Create;
    try
      lCurrentStatus := ReadString(lRoot, 'CurrentClaimStatus');
      lCurrentErrorText := ReadString(lRoot, 'CurrentErrorText');
      lComputedStatus := ReadString(lRoot, 'ComputedClaimStatus');
      lComputedErrorText := ReadString(lRoot, 'ComputedErrorText');
      lClaimInfo := ReadString(lRoot, 'ClaimInfo');
      lStatusExplanation := ReadString(lRoot, 'StatusExplanation');
      lAdjustmentInfo := ReadString(lRoot, 'LinkedAdjustmentInfo');
      lLegacyMessage := ReadString(lRoot, 'LegacyMessage');
      lAmountText := ReadString(lRoot, 'DonationAmountText');
      lDateText := ReadString(lRoot, 'DonationTransactionDateText');
      lDonationId := ReadInteger(lRoot, 'DonationId');
      lIsLocked := ReadBoolean(lRoot, 'IsLocked');

      if lCurrentStatus = '' then
        lCurrentStatus := 'Unknown';
      if lComputedStatus = '' then
        lComputedStatus := lCurrentStatus;

      FCurrentClaimStatus := lCurrentStatus;
      FCurrentErrorText := lCurrentErrorText;

      if lDonationId <= 0 then
      begin
        lLines.Add('Preview only: this is an unsaved donation and results are based on current form values.');
        lLines.Add('');
      end;

      lStatusMismatch := not SameText(lCurrentStatus, lComputedStatus);
      lShowReasons :=
        IsFailureClaimStatus(lCurrentStatus) or
        lStatusMismatch or
        IsFailureClaimStatus(lComputedStatus);

      lLines.Add(Format('This donation is currently %s.', [TUtils.SplitOnCaps(lCurrentStatus)]));
      if lStatusExplanation <> '' then
        lLines.Add(lStatusExplanation);
      if lStatusMismatch then
        lLines.Add(Format('GiftAider believes it should be %s.', [TUtils.SplitOnCaps(lComputedStatus)]));
      lLines.Add('');

      if (lDonationId > 0) and (not lIsLocked) then
      begin
        if ReadBoolean(lRoot, 'IsLegacyStatus') then
        begin
          if lLegacyMessage = '' then
            lLegacyMessage := 'This claim status appears outdated. Recalculate to update it';
          if not lStatusMismatch then
            lLines.Add(lLegacyMessage)
          else if Pos('Recalculate', lLegacyMessage) > 0 then
            lLines.Add('Recalculate to update the stored claim status.');
        end
        else if lStatusMismatch then
          lLines.Add('Recalculate to update the stored claim status.');
      end
      else if ReadBoolean(lRoot, 'IsLegacyStatus') and (lLegacyMessage <> '') then
        lLines.Add(lLegacyMessage);

      lLines.Add('GiftAider has assessed the donation against the Gift Aid claim rules and produced the following results:');

      if lClaimInfo <> '' then
      begin
        lLines.Add('');
        lLines.Add(lClaimInfo);
      end;

      if lAdjustmentInfo <> '' then
      begin
        if lClaimInfo = '' then
          lLines.Add('');
        lLines.Add(lAdjustmentInfo);
      end;

      lLines.Add('');

      if Assigned(lRoot) and Assigned(lRoot['Steps']) then
        lSteps := JS.ToArray(lRoot['Steps'])
      else
        lSteps := nil;

      if (lSteps = nil) or (lSteps.Length = 0) then
        lLines.Add('No checks were returned.')
      else
      begin
        for lI := 0 to lSteps.Length - 1 do
        begin
          lStep := TJSObject(lSteps[lI]);

          lLine := ReadString(lStep, 'Detail');
          if lLine = '' then
            lLine := ReadString(lStep, 'Title');

          if Trim(lLine) = '' then
            Continue;

          if ReadBoolean(lStep, 'Passed') then
            lPassedChecks.Add(lLine)
          else
            lReasons.Add(lLine);
        end;

        if lShowReasons and (lReasons.Count > 0) then
        begin
          lLines.Add('Reasons:');
          for lI := 0 to lReasons.Count - 1 do
            lLines.Add('❌ ' + lReasons[lI]);
          lLines.Add('');
        end
        else if lStatusMismatch and (lComputedErrorText <> '') then
        begin
          lLines.Add('Reasons:');
          lLines.Add('❌ ' + lComputedErrorText);
          lLines.Add('');
        end;

        lLines.Add('Checks passed:');
        if lPassedChecks.Count = 0 then
          lLines.Add('* None')
        else
          for lI := 0 to lPassedChecks.Count - 1 do
            lLines.Add('✅ ' + lPassedChecks[lI]);
      end;

      if lDonationId > 0 then
      begin
        if (lAmountText <> '') and (lDateText <> '') then
          HeaderLabel.Caption := Format('Donation Status Interrogation - £%s %s (#%d)',
            [lAmountText, lDateText, lDonationId])
        else
          HeaderLabel.Caption := Format('Donation Status Interrogation - (%d)', [lDonationId]);
      end
      else if (lAmountText <> '') and (lDateText <> '') then
        HeaderLabel.Caption := Format('Donation Status Interrogation - £%s %s (Preview)', [lAmountText, lDateText])
      else
        HeaderLabel.Caption := 'Donation Status Interrogation';

      if Assigned(DetailsMemo.ElementHandle) then
        TJSHTMLElement(DetailsMemo.ElementHandle).textContent := lLines.Text;

      if (FDonationId <= 0) and (lPreviewFingerprint <> '') then
      begin
        GLastPreviewInterrogationFingerprint := lPreviewFingerprint;
        GLastPreviewInterrogationHeader := HeaderLabel.Caption;
        GLastPreviewInterrogationText := lLines.Text;
        GLastPreviewInterrogationClaimStatus := FCurrentClaimStatus;
        GLastPreviewInterrogationErrorText := FCurrentErrorText;
      end;
    finally
      lPassedChecks.Free;
      lReasons.Free;
      lLines.Free;
    end;
  finally
    RefreshButton.Visible := (FDonationId > 0) and (not lIsLocked);
    RefreshButton.Enabled := RefreshButton.Visible;
  end;
end;

procedure TDonationClaimStatusInterrogationForm.RefreshButtonClick(Sender: TObject);
begin
  if FDonationId <= 0 then
    Exit;
  if not RefreshButton.Visible then
    Exit;
  if FRecalculateInProgress then
    Exit;

  FRecalculateInProgress := True;
  RefreshButton.Enabled := False;
  try
    await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.RecomputeDonationClaimStatus', [FDonationId]));
    FStatusRecomputed := True;
    await(LoadInterrogation);
  finally
    FRecalculateInProgress := False;
    RefreshButton.Enabled := RefreshButton.Visible;
  end;
end;

procedure TDonationClaimStatusInterrogationForm.CloseButtonClick(Sender: TObject);
begin
  ModalResult := mrOk;
end;

procedure TDonationClaimStatusInterrogationForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  HeaderLabel := TLabel.Create('DonationInterrogateHeader');
  DetailsMemo := THTMLDiv.Create('DonationInterrogateDetails');
  RefreshButton := TButton.Create('DonationInterrogateRefresh');
  CloseButton := TButton.Create('DonationInterrogateClose');

  HeaderLabel.BeforeLoadDFMValues;
  DetailsMemo.BeforeLoadDFMValues;
  RefreshButton.BeforeLoadDFMValues;
  CloseButton.BeforeLoadDFMValues;
  try
    Name := 'DonationClaimStatusInterrogationForm';
    Left := 0;
    Top := 0;
    Caption := 'Donation Status Interrogate';
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -12;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    SetEvent(Self, 'OnShow', 'WebFormShow');
    HeaderLabel.SetParentComponent(Self);
    HeaderLabel.Name := 'HeaderLabel';
    HeaderLabel.Left := 16;
    HeaderLabel.Top := 16;
    HeaderLabel.Width := 145;
    HeaderLabel.Height := 15;
    HeaderLabel.Caption := 'Donation Status Interrogate';
    HeaderLabel.Color := clBtnFace;
    HeaderLabel.ElementClassName := 'h5';
    HeaderLabel.ElementPosition := epIgnore;
    HeaderLabel.HeightPercent := 100.000000000000000000;
    HeaderLabel.WidthPercent := 100.000000000000000000;
    DetailsMemo.SetParentComponent(Self);
    DetailsMemo.Name := 'DetailsMemo';
    DetailsMemo.Left := 16;
    DetailsMemo.Top := 48;
    DetailsMemo.Width := 788;
    DetailsMemo.Height := 496;
    DetailsMemo.ElementClassName := 'p-1';
    DetailsMemo.HeightStyle := ssAuto;
    DetailsMemo.WidthStyle := ssAuto;
    DetailsMemo.ChildOrder := 1;
    DetailsMemo.ElementPosition := epIgnore;
    DetailsMemo.ElementFont := efCSS;
    DetailsMemo.Role := '';
    RefreshButton.SetParentComponent(Self);
    RefreshButton.Name := 'RefreshButton';
    RefreshButton.Left := 580;
    RefreshButton.Top := 556;
    RefreshButton.Width := 112;
    RefreshButton.Height := 28;
    RefreshButton.Caption := 'Recalculate';
    RefreshButton.ChildOrder := 2;
    RefreshButton.ElementClassName := 'btn btn-primary me-2';
    RefreshButton.ElementPosition := epIgnore;
    RefreshButton.HeightPercent := 100.000000000000000000;
    RefreshButton.WidthPercent := 100.000000000000000000;
    SetEvent(RefreshButton, Self, 'OnClick', 'RefreshButtonClick');
    CloseButton.SetParentComponent(Self);
    CloseButton.Name := 'CloseButton';
    CloseButton.Left := 708;
    CloseButton.Top := 556;
    CloseButton.Width := 96;
    CloseButton.Height := 28;
    CloseButton.Caption := 'Close';
    CloseButton.ChildOrder := 3;
    CloseButton.ElementClassName := 'btn btn-light';
    CloseButton.ElementPosition := epIgnore;
    CloseButton.HeightPercent := 100.000000000000000000;
    CloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseButton, Self, 'OnClick', 'CloseButtonClick');
  finally
    HeaderLabel.AfterLoadDFMValues;
    DetailsMemo.AfterLoadDFMValues;
    RefreshButton.AfterLoadDFMValues;
    CloseButton.AfterLoadDFMValues;
  end;
end;

end.

